module.exports = __webpack_public_path__ + "img/mask-home-banner-ko.0f65d538.png";